<template>
    <div>
        <div class="container container-tabs">
            <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
                <!-- <el-tab-pane name="all" class="to-searh">
                    <span slot="label" class="table-title">全部</span>
                </el-tab-pane> -->

                <el-tab-pane :name="String(item.key)" v-for="item in value_status_array" :key="item.key" class="to-searh">
                    <span slot="label" class="table-title">{{ item.value }}</span>
                </el-tab-pane>

             

                    <el-button @click="synchronization">同步</el-button>

                    <el-button icon="el-icon-refresh-right" @click="refresh">刷新 </el-button>
            
            </el-tabs>

            <el-card class="box-card">
                <div style="display: flex; flex-wrap: wrap">
                    <template v-for="(item2, index) in conf_data">
                        <!--activeUsers-->
                        <div
                            style="
                                width: 23%;
                                margin: 0 1% 20px;
                                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                                border-radius: 10px;
                                padding: 15px 0;
                            "
                            v-if="item2.is_show == 1"
                        >
                            <div style="text-align: center">
                                <p style="margin-top: 20px">
                                    {{ item2.name }}

                                    <el-popover placement="top" trigger="hover" :content="item2.description">
                                        <i class="el-icon-question" slot="reference" style="color: #999; cursor: pointer"></i>
                                    </el-popover>
                                </p>

                                <p style="font-size: 30px; height: 90px; line-height: 90px; font-weight: bold; color: #666">
                                    {{ item2.conf_value }}
                                </p>
                                <el-button
                                    type="text"
                                    style="padding: 6px 10px; margin: 10px 0; color: #ccc"
                                    @click="
                                        editRoleSubmitShow = !editRoleSubmitShow;
                                        editRole_data = item2;
                                    "
                                    >编辑 >
                                </el-button>
                            </div>
                        </div>
                    </template>
                </div>
            </el-card>
        </div>

        <!-- 编辑的弹窗子组件 -->
        <editConfSubmit :isShow="editRoleSubmitShow" :editRole_data="editRole_data" @submit_ok_return="confLists"> </editConfSubmit>
    </div>
</template>
<script>
var _this;

import editConfSubmit from '../conf/editConfSubmit';

export default {
    components: {
        editConfSubmit
    },

    computed: {
        activeUsers: function () {
            return this.conf_data.filter(function (user) {
                return user.is_show == 1;
            });
        }
    },

    data() {
        return {
            activeName: 'driver',
            value_status_array: '',
            city_name: '',

            conf_data: [],

            // 初始化页面时传入的参数
            search_data: {
                tab: 'driver'
            },

            //编辑的抽屉
            editRoleSubmitShow: false,

            // 点击编辑的时候传给子组件的值
            editRole_data: ''
        };
    },

    //生命周期，建立
    created() {
        _this = this;
        _this.getConfByTab();
        _this.confLists();


        //初始化显示列表

        // _this.confLists();
    },
    methods: {
        // 选项卡选中事件
      handleClick(tab, event) {
        // 点击的选项卡所对应的val值
        console.log(tab,'tab');
        _this.search_data.tab = tab.name;
        // if (tab.name != 'all') {
        //   _this.search_data.tab = tab.name;
        // } else {
        //   _this.search_data.tab = '';
        // }
 
        _this.confLists();

      },
       
      getConfByTab() {
        _this.$post(
            "/conf/getConfTab"
          )
          .then(res => {

            _this.value_status_array = res.data;
          }).catch((err) => {

          })



      },
        // 同步
        synchronization() {
            _this
                .$post('/conf/confInitialization')
                .then((res) => {
                    _this.$message.success('同步成功');
                    _this.confLists();
                })
                .catch((err) => {});
        },

        //搜索角色列表(初始化列表)
        confLists() {
            _this
                .$post('/conf/getConfByTab', _this.search_data)
                .then((res) => {
                    _this.conf_data = res.data;
                     console.log(_this.conf_data,'_this.conf_data');

                    _this.city_name = res.data[0].city.name;

                    _this.result_data = res;
                })
                .catch((err) => {});
        },

        //刷新页面
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.checkbox {
    position: absolute;
    margin-left: 21px;
    top: 20px;
}

.page {
    position: absolute;
    right: 0;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.box-card {
    margin-bottom: 20px;
}
</style>
